import script from "./CardTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./CardTemplate.vue?vue&type=script&setup=true&lang=js"

import "./CardTemplate.vue?vue&type=style&index=0&id=a04f32d2&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a04f32d2"]])

export default __exports__